import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LocationPin } from '@ml/locations/types';

@Component({
  selector: 'ml-customer-location-pin',
  template: `
    <div fxLayout="column">
      <div
        *ngFor="let pin of pins; let i = index"
        fxLayout="row"
        fxLayoutGap="16px"
        fxLayoutAlign="start center"
      >
        <div class="mat-title pin">{{ i + 1 }}</div>
        <mat-form-field class="full-width">
          <mat-label>{{ 'description' | translate | titlecase }}</mat-label>
          <input
            matInput
            [(ngModel)]="pin.description"
            maxlength="60"
            [disabled]="disable"
          />
          <mat-hint align="end">{{ pin.description?.length || 0 }}/60</mat-hint>
        </mat-form-field>

        <mat-slide-toggle
          *ngIf="!disable"
          [disabled]="pin.primary"
          [(ngModel)]="pin.primary"
          color="primary"
          (toggleChange)="onTogglePrimary(i)"
        >
          {{ 'primary' | translate | titlecase }}
        </mat-slide-toggle>

        <button
          *ngIf="!disable"
          [disabled]="pin.primary"
          mat-icon-button
          (click)="onRemove(i)"
        >
          <mat-icon svgIcon="delete"></mat-icon>
        </button>
      </div>
    </div>
  `,
  styleUrls: ['./customer-location-pin.component.scss']
})
export class CustomerLocationPinComponent implements OnInit {
  @Input() pins: LocationPin[];
  @Input() disable: boolean;

  @Output() remove = new EventEmitter<number>();
  @Output() primary = new EventEmitter<number>();

  constructor() {}

  ngOnInit() {}

  onTogglePrimary(index: number) {
    this.primary.emit(index);
  }

  onRemove(index: number) {
    this.remove.emit(index);
  }
}
